<div class="pre-login">
    <div class="pre-login-col-1 h-100">
        <left-panel-onboarding></left-panel-onboarding>
    </div>
    <div class="pre-login-col-2">
    </div>
    <div class="pre-login-col-3">
        <div class="onboarding-canvas h-100">
            <grid-row class="h-100 justify-content-center align-content-between">
              
                <grid-col col="12">
                    <div class="font-400 font-size-24px line-h-25 mt-30">
                        {{ "NameAppearCard" | translate }}
                    </div>
                    <div class="card justify-content-center mt-40">
                        <div class="img-box select-name">
                            <!-- <img src="~/../assets/images/card-titanium.png" alt=""> -->
                            <div class="text-box h-100-30">
                                <grid-row class="justify-content-center align-content-between h-100">
                                    <grid-col col="12">
                                        <grid-row class="align-item-center justify-content-between">
                                            <grid-col col="auto">
                                                <ng-icon iconClass="icon-creditcard-logo" width="60" height="27"></ng-icon>
                                            </grid-col>
                                            <grid-col col="auto">
                                                <ng-icon iconClass="icon-contactless" width="20" height="26"></ng-icon>
                                            </grid-col>
                                        </grid-row>
                                    </grid-col>
                                    <grid-col col="12">
                                        <div class="font-600 font-size-14px line-h-22 color-base-400 mt-16">
                                            MARIAM RASHID
                                        </div>
                                        <div class="font-500 font-size-14px line-h-20 mt-5">
                                            5270 170 8088 4924
                                        </div>
                                    </grid-col>
                                    <grid-col col="12">
                                        <grid-row class="justify-content-between align-item-center mt-7">
                                            <grid-col col="auto">
                                                <div>
                                                    <span class="font-400 font-size-10px line-h-14 color-base-400 mr-4">
                                                        {{"Expiry"| translate}}
                                                    </span>
                                                    <span class="font-600 font-size-10px line-h-14 mr-16">
                                                        04/26
                                                    </span>
                                                    <span class="font-400 font-size-10px line-h-14 color-base-400 mr-4">
                                                        {{"CVV" | translate}}
                                                    </span>
                                                    <span class="font-600 font-size-10px line-h-14">
                                                        •••
                                                    </span>
                                                </div>
                                            </grid-col>
                                            <grid-col col="auto">
                                                <ng-icon iconClass="icon-MasterCard" width="40" height="25"></ng-icon>
                                            </grid-col>
                                        </grid-row>
                                    </grid-col>
                                </grid-row>
                            </div>
                        </div>
                    </div>
                    <div class="custom-tabs-tags-2 mt-50 mb-50">
                        <div class="custom-tabs-tags-2-item" [ngClass]="activeTab == 1 ? 'active' : ''" (click)="changeTab(1)">
                            <div class="font-600 font-size-14px line-h-22 color-base-2200">
                                Mariam
                            </div>
                        </div>
                        <div class="custom-tabs-tags-2-item" [ngClass]="activeTab == 2 ? 'active' : ''" (click)="changeTab(2)">
                            <div class="font-600 font-size-14px line-h-22 color-base-2200">
                                Safiyyah
                            </div>
                        </div>
                        <div class="custom-tabs-tags-2-item" [ngClass]="activeTab == 3 ? 'active' : ''" (click)="changeTab(3)">
                            <div class="font-600 font-size-14px line-h-22 color-base-2200">
                                Binti
                            </div>
                        </div>
                        <div class="custom-tabs-tags-2-item" [ngClass]="activeTab == 4 ? 'active' : ''" (click)="changeTab(4)">
                            <div class="font-600 font-size-14px line-h-22 color-base-2200">
                                Zaza
                            </div>
                        </div>
                        <div class="custom-tabs-tags-2-item" [ngClass]="activeTab == 5 ? 'active' : ''" (click)="changeTab(5)">
                            <div class="font-600 font-size-14px line-h-22 color-base-2200">
                                Mar
                            </div>
                        </div>
                        <div class="custom-tabs-tags-2-item" [ngClass]="activeTab == 6 ? 'active' : ''" (click)="changeTab(6)">
                            <div class="font-600 font-size-14px line-h-22 color-base-2200">
                                Rashid
                            </div>
                        </div>
                    </div>
                </grid-col>
                <grid-col col="12">
                    <button class="btn-dft" (click)="payCardSuccess()">
                        {{ "NEXT" | translate }}
                    </button>
                </grid-col>
            </grid-row>
        </div>
    </div>
</div>